import { render, staticRenderFns } from "./DataTable-mod.vue?vue&type=template&id=b1e0ce9a"
import script from "./DataTable-mod.vue?vue&type=script&lang=js"
export * from "./DataTable-mod.vue?vue&type=script&lang=js"
import style0 from "./DataTable-mod.vue?vue&type=style&index=0&id=b1e0ce9a&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports